module.exports = __webpack_public_path__ + "img/ENERGIE_DICI_120X35.00306f00.png";